// --------------------------------------------
// Constants to be used in actions and reducers
// ---------------------------------------------
export const PATIENT_CONNECTION_INFO_REQUEST = `PATIENT_CONNECTION_INFO_REQUEST`;
export const PATIENT_CONNECTION_INFO_SUCCESS = `PATIENT_CONNECTION_INFO_SUCCESS`;
export const PATIENT_CONNECTION_INFO_FAILURE = `PATIENT_CONNECTION_INFO_FAILURE`;



// WEBPACK FOOTER //
// ./src/views/state/PatientConnectionInfo/types.js